/**
 * Google AdSense, loaded only when an ad slot is on screen for a visitor without a license.
 * Consent for EEA/UK/Swiss visitors comes from Google's own certified CMP ("Privacy & messaging"
 * in the AdSense dashboard), which this same script serves; nothing to code here.
 */
import { env } from "@/lib/env";

export type Placement = keyof typeof env.adsenseSlots;

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

/** The AdSense unit for a placement, or null when AdSense is not configured for it. */
export function adUnit(placement: Placement): { client: string; slot: string } | null {
  const slot = env.adsenseSlots[placement];
  return env.adsenseClient && slot ? { client: env.adsenseClient, slot } : null;
}

export function loadAdSense(client: string, doc: Document = document): void {
  if (doc.querySelector("script[data-adsense]")) return;
  const script = doc.createElement("script");
  script.async = true;
  script.crossOrigin = "anonymous";
  script.dataset.adsense = "";
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
  doc.head.appendChild(script);
}

/** Asks AdSense to fill an <ins class="adsbygoogle"> once (React may run effects twice). */
export function requestAd(element: HTMLElement): void {
  if (element.dataset.requested) return;
  element.dataset.requested = "true";
  (window.adsbygoogle = window.adsbygoogle || []).push({});
}
